<template>
  <div class="NavMenuItem" :class="NavMenuItemClass" @keyup.space="onClick_chooseAction" role="menuitem" :aria-haspopup="aria['haspopup']" :aria-level="level+1" tabindex="0">
    <header class="ripple" @click="onClick_chooseAction" :class="classObject">
      <i class="material-icons arrow" v-if="hasChildren()" :class="{ 'rotate-arrow': opened, 'normal-arrow': !opened }">
        keyboard_arrow_down
      </i>

      <div class="d-flex align-items-center w-100">
        <i class="icon" v-if="!hasChildren()" :class="iconClass" v-bind:style="{ 'background-image': 'url(' + iconImage + ')' }"></i>
        <span class="title text-wrap" v-html="this.item.titulo"></span>

        <div class="mx-auto"></div>

        <i v-if="isPhone && item.tipo_no == 0 && item.pdf" @click.capture="onClick_description" class="material-icons">description</i>
      </div>

      <div v-if="hasHistoricalSerie && !hasChildren() && !evolutionDisable" class="material-icons evolution-tag" role="tooltip" title="Este item possui uma série histórica">timeline</div>
    </header>

    <!-- Children -->
    <transition name="slide-down">
      <main v-if="hasChildren() && opened" role="menu" class="submenu">
        <p class="decor-vert" />
        <NavMenuItem v-for="i in item.children" :key="i.id" :item="i" :level="level + 1" :parent="selfRef" :evolutionDisable="evolutionDisable" :keepOneLevelOpen="keepOneLevelOpen" :branchAction="$props.branchAction" />
        <p class="menu-separator" role="separator" />
      </main>
    </transition>
  </div>
</template>

<script>
import map_icon from '#/static/img/map.png'
import text_icon from '#/static/img/texto.png'

import Summary from '@/js/Summary'

import { APPLICATION_PATH, PDFS_PATH } from '@/const'

export default {
  name: 'NavMenuItem',
  components: {
    NavMenuItem: () => import('@/components/ui/NavMenuItem')
  },
  props: {
    item: Object,
    level: Number,
    evolutionDisable: {
      type: Boolean,
      default: false,
    },
    keepOneLevelOpen: Function,
    parent: Object,
    branchAction: {
      type: Boolean,
      default: false,
    },
  },
  // Definição das funções injetadas aqui está na classe NavMenu.vue
  inject: ['selectedCallback', 'levelClickedCallback'],
  data() {
    return {
      opened: false,
      map_icon,
      text_icon,
      selfRef: this,
    }
  },
  computed: {
    aria() {
      return {
        'haspopup': this.hasChildren() ? true : false,
      }
    },
    hasHistoricalSerie() {
      //console.log(this.item.serie_id)
      return this.item.serie_id != null
    },

    selectedItem() {
      return this.$store.state.selectedItem
    },
    iconClass() {
      if (this.hasChildren()) {
        return []
      }

      let isMapItem = (this.item.tipo_no == 2)
      let iconClass = (isMapItem) ? ['prancha-mapa'] : ['prancha-texto']

      return iconClass
    },
    iconImage() {
      let isMapItem = this.item.tipo_no == 2
      let iconImage = (isMapItem) ? map_icon : text_icon

      return iconImage
    },
    classObject() {
      return {
        'color-black': this.hasChildren(),
        'border-left-color': this.isSubMenuOpen() || this.selectedItem == this.item,
      }
    },
    NavMenuItemClass() {
      return {
        'leaf': !this.hasChildren(),
        'branch': this.hasChildren(),
        'active-menu-item': this.isSubMenuOpen() || this.selectedItem == this.item,
        'ghost-item': this.ghost,
      }
    },
  },
  methods: {
    isPDF (url) {
      return getUrlExtension(url) == '.pdf'
    },
    hasChildren() {
      let childrenCount = ('children' in this.item) ? this.item.children.length : 0
      return childrenCount > 0
    },
    isSubMenuOpen() {
      return this.opened && this.hasChildren()
    },
    toggleSubMenu() {
      this.opened = !this.opened
      this.$emit('changeLevel', this.level + 1)
    },
    close () {
      this.opened = false
    },
    getAllParents () {
      let parent = this.parent
      let result = []

      if (parent) {
        result = [parent].concat(parent.getAllParents())
      }
      
      return result
    },

    // Events
    onClick_description (event) {
      this.$router.push({
        name: 'home.pdfdialog',
        params: { item: this.item }
      })

      event.stopPropagation()
    },
    onClick_chooseAction(event) {
      if (this.hasChildren()) {
        const half = document.getElementsByClassName("NavMenu")[0].offsetHeight / 2;

        this.keepOneLevelOpen(this)
        this.toggleSubMenu()
        
        if (this.branchAction) {
          this.selectedCallback(this.item)
        }

        const _this = this

        this.$nextTick(function () {
          setTimeout(function () {
            if (_this.$el.offsetTop > half) {
              _this.$parent.$el.scrollTop = half

            } else {
              _this.$parent.$el.scrollTop = 0
            }
          }, 300)
        })

      } else {
        this.selectedCallback(this.item)
      }
      event.stopPropagation()
    },
  }
}
</script>
